import styled from "styled-components";

import * as css from "styles/CssVariables.js";
import { AWS_PROFILE_IMAGES_URL } from "constants";
import { dateFormatted, getTimeAMPM } from "modules/functions";
import { Tooltip } from "react-tooltip";

import ButtonRoundIcon from "components/buttons/ButtonRoundIcon";

import profilePictureIcon from "assets/img/icons/icons8-profile-picture.svg";
import leftIcon from "assets/img/icons/left-arrow.svg";
import rightIcon from "assets/img/icons/right-arrow.svg";
import leftWhiteIcon from "assets/img/icons/left-arrow-white.svg";
import rightWhiteIcon from "assets/img/icons/right-arrow-white.svg";
import bronzeCheckmarkIcon from "assets/img/icons/checkmark-bronze.svg";
import silverCheckmarkIcon from "assets/img/icons/checkmark-silver.svg";
import goldCheckmarkIcon from "assets/img/icons/checkmark-gold.svg";

const AffiliateRevenuesBox = styled.div`
  width: 100%;
  min-height: 280px;
  padding: ${css.BOX_PADDING_PRIMARY};
  box-sizing: border-box;

  background: ${css.BLUE_BOX_GRADIENT};
  border-radius: ${css.BOX_RADIUS_PRIMARY};

  display: flex;
  justify-content: space-between;
  flex-direction: column;
  gap: 10px;
`;

const TableWrap = styled.div`
  width: 100%;
  padding-bottom: 5px;
  margin-bottom: -5px;

  overflow-x: auto;
`;

const ListTable = styled.table`
  width: 100%;
  min-width: 485px;
  max-width: 700px;
`;

const TableHead = styled.thead``;

const Label = styled.th`
  padding-bottom: 12px;
  width: ${(props) => (props.width ? props.width : "auto")};

  font-size: 18px;
  font-weight: 400;
  text-align: left;
`;

const TableBody = styled.tbody``;

const Cell = styled.td``;

const AvatarNameBox = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const AvatarIcon = styled.div`
  margin: 4px 0;

  width: 32px;
  min-width: 32px;
  height: 32px;
  background-image: ${(props) => `url(${props.image})`};
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 50%;

  border-radius: 16px;

  overflow: hidden;
`;

const Name = styled.div``;

const Pagination = styled.div`
  width: 100%;
  margin-top: ${css.VERTICAL_BOX_MARGIN_MEDIUM};

  display: flex;
  justify-content: center;
  gap: ${css.BUTTONS_GAP_SMALL};
`;

const UsernameBox = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

const CheckmarkIcon = styled.div`
  padding-top: 6px;

  width: 18px;
  min-width: 18px;
  height: 18px;
`;

export default ({ data, page, limit, paginate }) => {
  const { revenues, referralProfiles, checkmarkData, numOfResults } =
    data.affiliateRevenues;

  const list = revenues.map((revenue) => {
    let username = "Indirect referral";
    let profilePicture;

    if (revenue.level === "direct") {
      const profileData = referralProfiles.find(
        (profile) => profile.referral_id === revenue.referral_id
      );

      if (profileData) {
        profilePicture = profileData.data.profile_picture
          ? AWS_PROFILE_IMAGES_URL + profileData.data.profile_picture
          : profilePictureIcon;

        username = profileData.data.username;
      }
    }

    // preapare checkmark
    const referralCheckmarkData = checkmarkData.find(
      (data) => data.id === revenue.referral_id
    );

    const checkmark = referralCheckmarkData?.checkmark;

    let planIcon = goldCheckmarkIcon;
    let checkmarkInfo = "Gold Ad Plan";

    switch (checkmark) {
      case 1:
        planIcon = bronzeCheckmarkIcon;
        checkmarkInfo = "Bronze Ad Plan";
        break;
      case 2:
        planIcon = silverCheckmarkIcon;
        checkmarkInfo = "Silver Ad Plan";
        break;
    }

    return (
      <tr key={revenue.id}>
        <Cell>
          {dateFormatted(new Date(revenue.created_at), false) +
            ", " +
            getTimeAMPM(new Date(revenue.created_at))}
        </Cell>
        <Cell>{revenue.level === "direct" ? "Direct" : "Indirect"}</Cell>
        <Cell>
          <AvatarNameBox>
            <AvatarIcon
              image={
                revenue.level === "direct" ? profilePicture : profilePictureIcon
              }
            >
              {/* <img
                src={
                  revenue.level === "direct"
                    ? profilePicture
                    : profilePictureIcon
                }
                style={{ width: "100%", borderRadius: "50%" }}
              /> */}
            </AvatarIcon>
            <UsernameBox>
              <Name>{username}</Name>
              {checkmark && (
                <CheckmarkIcon
                  data-tooltip-id="checkmark-info"
                  data-tooltip-html={checkmarkInfo}
                  data-tooltip-place="top"
                  data-tooltip-delay-show={250}
                  onClick={(e) => e.stopPropagation()}
                >
                  <img src={planIcon} style={{ width: "100%" }} />
                </CheckmarkIcon>
              )}
              <Tooltip id="checkmark-info" className="tooltip" />
            </UsernameBox>
          </AvatarNameBox>
        </Cell>
        <Cell>${revenue.revenue} USD</Cell>
      </tr>
    );
  });

  let showPagination = false;

  if (numOfResults > limit) showPagination = true;

  const maxPage = Math.ceil(numOfResults / limit);

  return (
    <AffiliateRevenuesBox>
      <TableWrap className="table-wrap">
        <ListTable>
          <TableHead>
            <tr>
              <Label width="150px">Date</Label>
              <Label width="80px">Level</Label>
              <Label>Referral</Label>
              <Label width="100px">Revenue</Label>
            </tr>
          </TableHead>
          <TableBody>{list}</TableBody>
        </ListTable>
      </TableWrap>
      {showPagination && (
        <Pagination>
          {page > 1 && (
            <ButtonRoundIcon
              icon={leftIcon}
              hoverIcon={leftWhiteIcon}
              background={css.BRAND_YELLOW}
              hoverBackground={css.BRAND_GREEN}
              iconSize="16px"
              buttonSize="32px"
              onClick={() => paginate("previous")}
            />
          )}
          {page < maxPage && (
            <ButtonRoundIcon
              icon={rightIcon}
              hoverIcon={rightWhiteIcon}
              background={css.BRAND_YELLOW}
              hoverBackground={css.BRAND_GREEN}
              iconSize="16px"
              buttonSize="32px"
              onClick={() => paginate("next")}
            />
          )}
        </Pagination>
      )}
    </AffiliateRevenuesBox>
  );
};
